'use client';
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = Dropdown;
exports.DropdownButton = DropdownButton;
exports.DropdownMenu = DropdownMenu;
exports.DropdownItem = DropdownItem;
exports.DropdownHeader = DropdownHeader;
exports.DropdownSection = DropdownSection;
exports.DropdownHeading = DropdownHeading;
exports.DropdownDivider = DropdownDivider;
exports.DropdownLabel = DropdownLabel;
exports.DropdownDescription = DropdownDescription;
exports.DropdownShortcut = DropdownShortcut;
const jsx_runtime_1 = require("react/jsx-runtime");
const Headless = __importStar(require("@headlessui/react"));
const clsx_1 = require("clsx");
const button_1 = __importDefault(require("./button"));
// Headless UI menu, restyled for AIQ. The menu surface uses 12px radius +
// --aiq-shadow-md + neutral-100 border (the popover treatment). Items hover
// neutral-50; focused / keyboard-active items use primary-50 + primary-800 text.
function Dropdown(props) {
    return (0, jsx_runtime_1.jsx)(Headless.Menu, Object.assign({}, props));
}
function DropdownButton(_a) {
    var { as = button_1.default } = _a, props = __rest(_a, ["as"]);
    return (0, jsx_runtime_1.jsx)(Headless.MenuButton, Object.assign({ as: as }, props));
}
function DropdownMenu(_a) {
    var { anchor = 'bottom', className } = _a, props = __rest(_a, ["anchor", "className"]);
    return ((0, jsx_runtime_1.jsx)(Headless.MenuItems, Object.assign({}, props, { anchor: anchor, className: (0, clsx_1.clsx)(className, '[--anchor-gap:--spacing(2)] [--anchor-padding:--spacing(1)] data-[anchor~=end]:[--anchor-offset:6px] data-[anchor~=start]:[--anchor-offset:-6px] sm:data-[anchor~=end]:[--anchor-offset:4px] sm:data-[anchor~=start]:[--anchor-offset:-4px]', 'isolate w-max rounded-xl border border-neutral-100 bg-surface p-1 shadow-md', 'outline outline-transparent focus:outline-hidden', 'overflow-y-auto', 'supports-[grid-template-columns:subgrid]:grid supports-[grid-template-columns:subgrid]:grid-cols-[auto_1fr_1.5rem_0.5rem_auto]', 'transition data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0'), transition: true })));
}
function DropdownItem(_a) {
    var { className, as = 'button' } = _a, props = __rest(_a, ["className", "as"]);
    const classes = (0, clsx_1.clsx)(className, 'group cursor-pointer rounded-lg px-3 py-2 focus:outline-hidden', 'text-left text-sm text-neutral-900 forced-colors:text-[CanvasText]', 'data-focus:bg-primary-50 data-focus:text-primary-800', 'data-disabled:cursor-not-allowed data-disabled:opacity-50', 'forced-color-adjust-none forced-colors:data-focus:bg-[Highlight] forced-colors:data-focus:text-[HighlightText] forced-colors:data-focus:*:data-[slot=icon]:text-[HighlightText]', 'col-span-full grid grid-cols-[auto_1fr_1.5rem_0.5rem_auto] items-center supports-[grid-template-columns:subgrid]:grid-cols-subgrid', '*:data-[slot=icon]:col-start-1 *:data-[slot=icon]:row-start-1 *:data-[slot=icon]:mr-2.5 *:data-[slot=icon]:-ml-0.5 *:data-[slot=icon]:size-4', '*:data-[slot=icon]:text-neutral-400 data-focus:*:data-[slot=icon]:text-primary-700', '*:data-[slot=avatar]:mr-2.5 *:data-[slot=avatar]:-ml-1 *:data-[slot=avatar]:size-5');
    return (0, jsx_runtime_1.jsx)(Headless.MenuItem, Object.assign({ as: as, type: as === 'button' ? 'button' : undefined }, props, { className: classes }));
}
function DropdownHeader(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (0, jsx_runtime_1.jsx)("div", Object.assign({}, props, { className: (0, clsx_1.clsx)(className, 'col-span-5 px-3 pt-2 pb-1') }));
}
function DropdownSection(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return ((0, jsx_runtime_1.jsx)(Headless.MenuSection, Object.assign({}, props, { className: (0, clsx_1.clsx)(className, 'col-span-full supports-[grid-template-columns:subgrid]:grid supports-[grid-template-columns:subgrid]:grid-cols-[auto_1fr_1.5rem_0.5rem_auto]') })));
}
function DropdownHeading(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return ((0, jsx_runtime_1.jsx)(Headless.MenuHeading, Object.assign({}, props, { className: (0, clsx_1.clsx)(className, 'col-span-full grid grid-cols-[1fr_auto] gap-x-12 px-3 pt-2 pb-1 text-[11px] font-bold uppercase tracking-[0.06em] text-neutral-500') })));
}
function DropdownDivider(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (0, jsx_runtime_1.jsx)(Headless.MenuSeparator, Object.assign({}, props, { className: (0, clsx_1.clsx)(className, 'col-span-full mx-2 my-1 h-px border-0 bg-neutral-100 forced-colors:bg-[CanvasText]') }));
}
// Note: Catalyst's original `DropdownLabel`/`DropdownDescription` wrap Headless
// UI's <Label>/<Description>, but those primitives require a Field-like context
// that `MenuItem` does not provide — Headless v2 throws "You used a <Label />
// component, but it is not inside a relevant parent". Render plain elements
// here; we only need the layout/styling, not field association.
function DropdownLabel(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (0, jsx_runtime_1.jsx)("span", Object.assign({ "data-slot": 'label' }, props, { className: (0, clsx_1.clsx)(className, 'col-start-2 row-start-1') }));
}
function DropdownDescription(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return ((0, jsx_runtime_1.jsx)("span", Object.assign({ "data-slot": 'description' }, props, { className: (0, clsx_1.clsx)(className, 'col-span-2 col-start-2 row-start-2 text-xs text-neutral-500 group-data-focus:text-primary-700 forced-colors:group-data-focus:text-[HighlightText]') })));
}
function DropdownShortcut(_a) {
    var { keys, className } = _a, props = __rest(_a, ["keys", "className"]);
    return ((0, jsx_runtime_1.jsx)(Headless.Description, Object.assign({ as: 'kbd' }, props, { className: (0, clsx_1.clsx)(className, 'col-start-5 row-start-1 flex justify-self-end'), children: (Array.isArray(keys) ? keys : keys.split('')).map((char, index) => ((0, jsx_runtime_1.jsx)("kbd", { className: (0, clsx_1.clsx)([
                'min-w-[2ch] text-center font-sans capitalize text-neutral-400 group-data-focus:text-primary-700 forced-colors:group-data-focus:text-[HighlightText]',
                index > 0 && char.length > 1 && 'pl-1'
            ]), children: char }, index))) })));
}
